(function () {
  'use strict';
  if (window.mzCymSizeFit) return;
  window.mzCymSizeFit = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var details = new Set();
  var queued = false;
  var observer = new ResizeObserver(schedule);

  function visibleWidth(element) {
    if (!element || element.classList.contains('visually-hidden')) return 0;
    return element.getBoundingClientRect().width;
  }

  function measure(detail, rating, stars) {
    var style = getComputedStyle(detail);
    var ratingStyle = getComputedStyle(rating);
    var maximum = parseFloat(ratingStyle.fontSize);
    var minimum = parseFloat(ratingStyle.getPropertyValue('--mz-cym-rating-min-star-size'));
    var gap = parseFloat(ratingStyle.columnGap) || 0;
    var size = detail.querySelector('.mz-cym-row__size');
    var available = detail.getBoundingClientRect().width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    if (size) available -= size.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
    var unitWidth = stars.getBoundingClientRect().width / maximum;
    var countWidth = visibleWidth(rating.querySelector('.mz-cym-row__rating-count'));
    var averageWidth = visibleWidth(rating.querySelector('.mz-cym-row__rating-value'));
    var mode = 'full';
    if (!(maximum > 0 && minimum > 0 && unitWidth > 0)) {
      return { rating: rating, mode: 'stars-hidden' };
    }
    minimum = Math.min(minimum, maximum);

    function starSize() {
      var gaps = (countWidth > 0 ? 1 : 0) + (averageWidth > 0 ? 1 : 0);
      return (available - countWidth - averageWidth - gap * gaps) / unitWidth;
    }

    var chosen = starSize();
    if (chosen < minimum) {
      countWidth = 0;
      mode = 'count-hidden';
      chosen = starSize();
    }
    if (chosen < minimum && averageWidth > 0) {
      averageWidth = 0;
      mode = 'average-hidden';
      chosen = starSize();
    }
    if (chosen < minimum) {
      return { rating: rating, mode: 'stars-hidden' };
    }
    return { rating: rating, mode: mode, size: Math.min(maximum, chosen) + 'px' };
  }

  function flush() {
    queued = false;
    var rows = [];
    details.forEach(function (detail) {
      if (!detail.isConnected) {
        observer.unobserve(detail);
        details.delete(detail);
      } else {
        var rating = detail.querySelector('.mz-cym-row__rating');
        var stars = rating && rating.querySelector('.mz-cym-row__stars');
        if (stars) rows.push({ detail: detail, rating: rating, stars: stars });
      }
    });
    rows.forEach(function (row) {
      delete row.rating.dataset.mzCymRatingFit;
      row.rating.style.removeProperty('--mz-cym-fit-star-size');
    });
    if (!phone.matches) return;
    var fits = rows.map(function (row) { return measure(row.detail, row.rating, row.stars); });
    fits.forEach(function (fit) {
      if (fit.size) fit.rating.style.setProperty('--mz-cym-fit-star-size', fit.size);
      fit.rating.dataset.mzCymRatingFit = fit.mode;
    });
  }

  function schedule() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(flush);
    }
  }

  function collect(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var found = Array.from(root.querySelectorAll('.mz-cym-row__details'));
    if (root.matches && root.matches('.mz-cym-row__details')) found.push(root);
    found.forEach(function (detail) {
      if (!details.has(detail)) {
        details.add(detail);
        observer.observe(detail);
      }
    });
    if (found.length) schedule();
  }

  function start() {
    collect(document);
    new MutationObserver(function (records) {
      var affected = false;
      records.forEach(function (record) {
        record.addedNodes.forEach(collect);
        if (record.target.nodeType === 1 && record.target.closest('.mz-cym-row__details')) affected = true;
        record.removedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.matches('.mz-cym-row__details') || node.querySelector('.mz-cym-row__details'))) affected = true;
        });
      });
      if (affected) schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { collect(event.target); });
    phone.addEventListener('change', schedule);
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
